/* formsy-react-components wrappers to provide common functionality */

import { Checkbox as FRCCheckbox, Form, Input, Select, Textarea } from 'formsy-react-components';
import * as _ from 'lodash';
import * as React from 'react';
import { Button, ButtonToolbar } from 'react-bootstrap';

const FormsyInputProps = ({ ...rest }, castValueToString: boolean = true) => {
    let inputProps = Object.assign({}, { rowClassName: [{ 'form-group': false }] }, rest);

    // id property
    if (_.get(inputProps, 'id', '') !== _.get(rest, 'name', '')) {
        inputProps.id = _.get(rest, 'name', '');
    }

    // Value property
    const inputValue = String(_.get(inputProps, 'value', ''));
    const restValue = String(_.get(rest, 'value', ''));
    if (inputValue !== restValue) { inputProps.value = restValue; }

    if (castValueToString) { inputProps.value = String(inputProps.value); }

    const labelSuffix = _.get(rest, 'labelSuffix', '');
    const inputLabel = String(_.get(rest, 'label', '')) + labelSuffix;
    inputProps.label = inputLabel;

    if (_.get(inputProps, 'className', '') !== _.get(rest, 'className', '')) {
        inputProps.className = _.get(rest, 'className', '');
    }

    if (_.has(rest, 'checked')) {
        inputProps.checked = (_.get(rest, 'checked', false)) ? true : false;
        inputProps.value = (_.get(rest, 'checked', false)) ? true : false;
        // _.unset(inputProps, 'value');
    }

    return inputProps;
};

const FormsyInput = ({ ...rest }) => {
    // Returns a formsy Input contro l of specified type & configuration
    const { noValue, ...inputProps } = FormsyInputProps(rest);

    return (
        <Input {...inputProps} />
    );
};

export const FormsySelect = ({ ...rest }) => {
    // Return a formsy Select control
    let inputProps = FormsyInputProps(rest);

    return (
        <Select {...inputProps} />);
};

export const FormsyTextarea = ({ ...rest }) => {
    // Returns a formsy textarea control
    let inputProps = FormsyInputProps(rest);

    inputProps.rows = _.get(rest, 'rows', 3);
    inputProps.cols = _.get(rest, 'cols', 40);

    return (
        <Textarea {...inputProps} />
    );
};

export const FormsyTextInput = ({ ...rest }) => {
    // Returns a formsy input for text

    let inputProps = FormsyInputProps(rest);

    inputProps.type = 'text';

    return (
        <FormsyInput {...inputProps} />
    );
};

export const FormsyNumberInput = ({ ...rest }) => {
    // Returns a formsy input for numbers

    let inputProps = FormsyInputProps(rest);

    inputProps.type = 'number';

    return (
        <FormsyInput {...inputProps} />
    );
};

export const FormsyMonthsInput = ({ monthsText = 'Months', ...rest }) => {
    // Returns a formsy input for periods aka months
    const addonSymbol: string = monthsText;

    let inputProps = FormsyInputProps(rest);

    inputProps.type = 'number';
    inputProps.min = _.get(rest, 'min', 1);
    inputProps.max = _.get(rest, 'max', 12);
    inputProps.step = _.get(rest, 'step', 1);
    inputProps.value = Number(_.get(rest, 'value', inputProps.min));

    if (!_.get(rest, 'addonAfter') && addonSymbol) { inputProps.addonAfter = (<span>{addonSymbol}</span>); }

    return (
        <FormsyInput {...inputProps} />
    );
};

export const FormsyPercentageInput = ({ decimals = 5, ...rest }) => {
    // Returns a formsy input for percentage values
    const addonSymbol: string = '%';

    let inputProps = FormsyInputProps(rest);

    inputProps.type = 'number';
    inputProps.min = _.get(rest, 'min', 0.00); // .get(rest, 'min', 0.00001);
    inputProps.max = _.get(rest, 'max', 100.00);
    inputProps.step = _.get(rest, 'step', 0.00001);
    inputProps.value = Number(_.get(rest, 'value', inputProps.min)).toFixed(decimals);

    if (!_.get(rest, 'addonAfter') && addonSymbol) { inputProps.addonAfter = (<span>{addonSymbol}</span>); }

    return (
        <FormsyInput {...inputProps} />
    );
};

export const FormsyCurrencyInput = ({ decimals = 2, ...rest }) => {
    // Returns a formsy input for currency decimal values
    const addonSymbol: string = '$';

    let inputProps = FormsyInputProps(rest);

    inputProps.type = 'number';
    // inputProps.min = _.get(rest, 'min', 0.00);
    inputProps.step = _.get(rest, 'step', 0.01);
    inputProps.value = Number(_.get(rest, 'value', inputProps.min)).toFixed(decimals);

    if (!_.get(rest, 'addonBefore') && addonSymbol) { inputProps.addonBefore = (<span>{addonSymbol}</span>); }

    return (
        <FormsyInput {...inputProps} />
    );
};

export const FormsySingleYearInput = ({ ...rest }) => {
    // Returns a formsy input for integer single year
    let inputProps = FormsyInputProps(rest);

    inputProps.type = 'number';
    inputProps.min = _.get(rest, 'min', 2000);
    inputProps.max = _.get(rest, 'max', 2200);
    inputProps.step = _.get(rest, 'step', 1);

    return (
        <FormsyInput {...inputProps} />
    );
};

export const FormsyDateInput = ({ ...rest }) => {
    // Returns a formsy input for dates
    let inputProps = FormsyInputProps(rest);

    inputProps.type = 'date';
    inputProps.min = _.get(rest, 'min', '2000-01-01');
    inputProps.max = _.get(rest, 'max', '2200-12-31');

    return (
        <FormsyInput {...inputProps} />
    );
};

export const FormsyYearsInput = ({ yearsText = 'Years', ...rest }) => {
    // Returns a formsy input for integer year counts
    const addonSymbol: string = yearsText;

    let inputProps = FormsyInputProps(rest);

    inputProps.type = 'number';
    inputProps.min = _.get(rest, 'min', 0);
    inputProps.step = _.get(rest, 'step', 1);

    if (!_.get(rest, 'addonAfter') && addonSymbol) { inputProps.addonAfter = (<span>{addonSymbol}</span>); }

    return (
        <FormsyInput {...inputProps} />
    );
};

export const FormsyCheckbox = ({ ...rest }) => {
    // Returns a formsy checkbox control
    rest.checked = true;
    // rest.className = 'form-control';

    // console.log(`FormsyCheckbox rest`, rest);

    let inputProps = FormsyInputProps(rest, false);

    // console.log(`FormsyCheckbox inputProps`, inputProps);

    return (
        <FRCCheckbox {...inputProps} />
    );

    // return (
    //     <FormsyInput type="checkbox" {...inputProps} />
    // );
};

export const FormsyDisabledInputHidden = ({ classNameAdded = 'input-hidden', ...rest }) => {
    // Returns a formsy input for disabled values

    rest.className += ` ${classNameAdded}`;

    let inputProps = FormsyInputProps(rest);

    inputProps.type = 'text';
    inputProps.readOnly = true;
    inputProps.disabled = true;

    return (
        <FormsyInput {...inputProps} />
    );
};

export const FormsyVerticalForm = ({ children, ...rest }) => {
    // Returns a Formsy <Form> tag with default options
    let inputProps = Object.assign({}, { layout: 'vertical' }, rest);

    return (
        <Form {...inputProps}>
            {...children}
        </Form>
    );
};

export const FormsyHorizontalForm = ({ children, ...rest }) => {
    // Returns a Formsy <Form> tag with default options
    let inputProps = Object.assign({}, { layout: 'horizontal' }, rest);

    return (
        <Form {...inputProps}>
            {...children}
        </Form>
    );
};

export const FormsyFormSection = ({ title, children, ...rest }) => {
    // Returns a form section block
    let inputProps = Object.assign({}, rest);

    return (
        <div className="form-section" {...inputProps}>
            <div className="form-section-title">{title}</div>
            {...children}
        </div>
    );
};

export const FormsyButtonToolbar = ({ submitText, cancelText, onCancel, ...rest }) => {
    // Returns form button toolbar

    return (
        <ButtonToolbar {...rest}>
            <Button type="button" bsStyle="danger" onClick={onCancel}>{cancelText}</Button>
            <Button type="submit" bsStyle="success">{submitText}</Button>
        </ButtonToolbar>
    );
};



// WEBPACK FOOTER //
// ./src/common/formsy/componentwrappers.tsx